import React from 'react'
import Check from 'svg/complete-check.svg'
import Close from 'svg/close.svg'
import SALink from 'components/SALink'
import styles from '../ArtAdvisory.module.scss'
import classNames from 'classnames'
const TITLE = 'Browse Curators Collections'
type Props = {
  hasCompleted: boolean
  handleState: React.Dispatch<React.SetStateAction<Object>>
}

const Component = (props: Props) => {
  const { hasCompleted, handleState } = props
  return (
    <div
      className={classNames({
        [styles.submitSuccessHide]: !hasCompleted,
      })}
    >
      <Close
        className={styles.close}
        onClick={() =>
          handleState((prevState) => ({ ...prevState, hasCompleted: false, errorMessage: '' }))
        }
      />
      <div
        data-type='submit-success'
        className={classNames(
          {
            [styles.submitSuccessHide]: !hasCompleted,
          },
          styles.submitSuccess
        )}
      >
        <h2 className={`${styles.submitSuccessTitle} defaultTypographyH2`}>Thank You!</h2>
        <Check className={styles.check} />
        <p className={`${styles.submitSuccessText} defaultTypographyMedium`}>
          Your personally assigned curator will be in contact with you in the next 2 business days
          to begin your consultation.
        </p>

        <SALink href='/collections/all' title={TITLE} data-type='collection-link'>
          <div className={`${styles.collectionButton} defaultButtonGunMetal`}>
            <p className='defaultTypographyCtaLarge, defaultTextUppercase'>{TITLE}</p>
          </div>
        </SALink>
      </div>
    </div>
  )
}

export default Component
